import { render, staticRenderFns } from "./ChangeUsernamePage.vue?vue&type=template&id=503dc05a&scoped=true&"
import script from "./ChangeUsernamePage.vue?vue&type=script&lang=js&"
export * from "./ChangeUsernamePage.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUsernamePage.vue?vue&type=style&index=0&id=503dc05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503dc05a",
  null
  
)

export default component.exports